/**
 * 군수품 아이콘. 장비 아이콘(`items.ts`)과 같은 방식이다: 한 장의 시트(`public/sprites/supplies.png`)에 `SUPPLIES` 순서대로
 * 32픽셀 칸이 한 줄로 늘어서 있다. 순서가 곧 자리라 따로 색인 표를 두지 않는다 — 군수품을 더하면 `tools/supplies_pack.py`로
 * 시트를 다시 굽는다(`tests/supply-icons.test.ts`가 시트 크기와 군수품 수가 맞는지 본다).
 *
 * 플레이한 사람이 청했다: "군수품도 장비처럼 아이콘들을 만들고 레이아웃을 개선해보자. 지금은 너무 목록이 길고 화면을
 * 많이 차지하네." 그림은 Codex가 그렸다(`art/source/REQ_supplies.md`).
 */
import { SUPPLIES } from '../sim/supplies.ts';
import { el } from './dom.ts';

/** 시트의 칸 크기(픽셀)와 한 줄의 칸 수. `tools/supplies_pack.py`와 같아야 한다. */
export const SUPPLY_CELL = 32;
export const SUPPLY_COLS = 8;

const INDEX = new Map(SUPPLIES.map((s, k) => [s.id, k]));

/** 아이콘 한 칸. `size`는 화면 픽셀. 도트 그림이라 `image-rendering: pixelated`로 그린다(CSS `.supply-icon`). */
export function supplyIcon(id: string, size = 32): HTMLElement {
  const k = INDEX.get(id as never) ?? 0;
  const scale = size / SUPPLY_CELL;
  const rows = Math.ceil(SUPPLIES.length / SUPPLY_COLS);
  const span = el('span', { class: 'supply-icon', 'aria-hidden': 'true' });
  span.style.width = `${size}px`;
  span.style.height = `${size}px`;
  span.style.backgroundSize = `${SUPPLY_COLS * SUPPLY_CELL * scale}px ${rows * SUPPLY_CELL * scale}px`;
  span.style.backgroundPosition = `${-(k % SUPPLY_COLS) * SUPPLY_CELL * scale}px ${-Math.floor(k / SUPPLY_COLS) * SUPPLY_CELL * scale}px`;
  return span;
}
